import { useMemo } from 'react';
import NsContent from 'components/common/ns-content/NsContent';

import { PsrItem } from './PsrItem';
import { NsExpander } from 'components/common/ns-expander/NsExpander';
import type { PsrType } from '../psr-types';
export const testId = 'psrSectionTestId';

type PsrSectionProps = {
  psrSection: PsrType;
};

export const PsrSection = ({ psrSection }: PsrSectionProps) => {
  const expandable = !!(psrSection.subCodes || []).length;

  return useMemo(
    () => (
      <section data-testid={testId}>
        <NsContent>
          {expandable ? (
            <NsExpander heading={psrSection.displayName}>
              {psrSection.description && <p>{psrSection.description}</p>}
              {psrSection.subCodes?.map((item) => {
                return (
                  <PsrItem
                    psrItem={{ ...item, type: psrSection.type }}
                    parentCode={psrSection.code}
                    key={item.code}
                  />
                );
              })}
            </NsExpander>
          ) : (
            <PsrItem key={psrSection.code} psrItem={psrSection} />
          )}
        </NsContent>
      </section>
    ),
    [expandable, psrSection]
  );
};
